"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderCatalogPartnerModal = exports.CatalogPartnerModalLoader = void 0;
var react_1 = __importStar(require("react"));
var ui_1 = require("@aperza/ui");
var react_dom_1 = __importDefault(require("react-dom"));
var CatalogPartnerModal_1 = __importDefault(require("./CatalogPartnerModal"));
var CatalogPartnerModalLoader = function () {
    var _a = __read(react_1.useState(), 2), documentId = _a[0], setDocumentId = _a[1];
    var _b = __read(react_1.useState(false), 2), show = _b[0], setShow = _b[1];
    var getMessage = ui_1.useReactiveMessage('CATALOG_PARTNER').getMessage;
    var subscription;
    react_1.useEffect(function () {
        subscription = getMessage().subscribe(function (message) {
            if (message && message.documentId) {
                setDocumentId(message.documentId);
                setShow(true);
            }
        });
    });
    var onCloseHandler = function () {
        setShow(false);
    };
    return (react_1.default.createElement(CatalogPartnerModal_1.default, { documentId: documentId, show: show, onCloseHandler: onCloseHandler }));
};
exports.CatalogPartnerModalLoader = CatalogPartnerModalLoader;
exports.CatalogPartnerModalLoader.displayName = 'CatalogPartnerModalLoader';
exports.default = exports.CatalogPartnerModalLoader;
var renderCatalogPartnerModal = function () {
    var modalId = 'aperza-catalog-partner-preview-modal';
    var modal = document.getElementById(modalId);
    if (!modal) {
        var aperzaCatalogPartnerPreviewModal = document.createElement('div');
        aperzaCatalogPartnerPreviewModal.id = modalId;
        document.body.appendChild(aperzaCatalogPartnerPreviewModal);
        console.log('ADD aperzaCatalogPartnerPreviewModal');
        react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null) },
            react_1.default.createElement(exports.CatalogPartnerModalLoader, null)), aperzaCatalogPartnerPreviewModal);
    }
    else {
        console.warn("Trying to create additional modal: " + modalId);
    }
};
exports.renderCatalogPartnerModal = renderCatalogPartnerModal;
